import { Overlay } from "@omni/components/components/General/Overlay/overlay";
import { SearchBar } from "@omni/components/components/Search/SearchBar/searchBar";
import { cn } from "@omni/utils/styles";

import { ResultsPanel } from "@/components/Search/SearchBar/components/ResultsPanel/resultsPanel.container";
import { SearchBox } from "@/components/Search/SearchBar/components/SearchBox/searchBox.container";

type Props = {
    className?: string;
};

export const SearchBarComponent = ({ className }: Props) => {
    const { isOpen, props, onKeyDown, onOpen, onClose } =
        SearchBar.useContext();

    return (
        <div className={cn(className)}>
            <div
                {...props.root}
                className={cn("tw:group/autocomplete", {
                    "tw:bg-white tw:layer-modal/[2] tw:py-4 tw:page-container tw:fixed tw:w-full tw:h-full tw:top-0 tw:left-0":
                        isOpen,
                    "tw:lg:bg-transparent tw:lg:top-header-top-bar-desktop tw:lg:w-[calc(992px-4rem-80px)] tw:px-4 tw:py-5.25 tw:lg:h-auto tw:lg:rounded-lg tw:lg:left-[calc(50%-calc(992px-4rem-80px)/2)]":
                        isOpen,
                    "tw:xl:w-[calc(992px-1rem-80px)] tw:xl:left-[initial] tw:xl:-translate-x-4":
                        isOpen,
                    "tw:rounded-sm": !isOpen
                })}
                onClick={onOpen}
                onKeyDown={onKeyDown}
            >
                <SearchBox />
                <ResultsPanel />
            </div>
            <Overlay
                open={isOpen}
                onClose={onClose}
                overlayHeader={true}
                scrollLock={false}
            >
                <Overlay.Content />
            </Overlay>
        </div>
    );
};
